module.exports = __webpack_public_path__ + "static/media/water-icon@2x.73e495e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/water-icon@2x.png
// module id = 294
// module chunks = 0